import { mPerLat, mPerLon } from './geo';
// planning studio: line styles, hatch patterns, quantities
export const LINE_STYLES = { solid: '#0f172a', dashed: '#334155', wall: '#57534e', fence: '#78350f', hedge: '#15803d', drain: '#0284c7', flow: '#2563eb' };
export const PATTERNS = { gravel: '#a8a29e', sand: '#fde68a', concrete: '#cbd5e1', paving: '#d6d3d1', grass: '#86efac', wood: '#fcd34d' };
export const TOOLS = ['line', 'area', 'dim', 'note'];
export const BUILD_LINES = ['solid', 'dashed', 'wall', 'fence'];
export const BUILD_PATTERNS = ['gravel', 'sand', 'concrete', 'paving', 'wood'];
// building hides garden / drainage styles
export const styleKeys = (tool, mode) => (tool === 'area' ? (mode === 'building' ? BUILD_PATTERNS : Object.keys(PATTERNS)) : tool === 'line' ? (mode === 'building' ? BUILD_LINES : Object.keys(LINE_STYLES)) : []);

const rad = Math.PI / 180;
export const segLen = (a, b) => Math.hypot((b[1] - a[1]) * mPerLon(a[0]), (b[0] - a[0]) * mPerLat(a[0]));
export const lineLen = (P) => P.slice(1).reduce((s, p, i) => s + segLen(P[i], p), 0);
export function polyArea(P) {
  const la = P[0][0], k = mPerLon(la), Q = P.map((p) => [p[1] * k, p[0] * mPerLat(la)]);
  return Math.abs(Q.reduce((s, p, i) => { const q = Q[(i + 1) % Q.length]; return s + p[0] * q[1] - q[0] * p[1]; }, 0)) / 2;
}
export const qtyOf = (d) => (d.kind === 'area' ? polyArea(d.pts) : d.kind === 'line' ? lineLen(d.pts) : 0);
// actual (as-built) quantity overrides the planned geometry when corrected on site
export const builtQty = (d) => (d.actual?.qty != null && d.actual.qty !== '' ? +d.actual.qty : qtyOf(d));

export function drawSummary(list = []) {
  const g = {};
  list.filter((d) => d.kind === 'line' || d.kind === 'area').forEach((d) => {
    const k = `${d.kind}:${d.style}`, r = g[k] || (g[k] = { kind: d.kind, style: d.style, plan: 0, built: 0, n: 0 });
    r.n += 1;
    if (d.status === 'built') r.built += builtQty(d); else r.plan += qtyOf(d);
  });
  return Object.values(g);
}

// SVG hatch patterns (one hidden defs block in the document, referenced via fill="url(#pat-x)")
export function ensurePatterns() {
  if (document.getElementById('giss-pat-defs')) return;
  const P = {
    gravel: '<rect width="12" height="12" fill="#e7e5e4"/><circle cx="3" cy="3" r="2" fill="none" stroke="#57534e" stroke-width="1"/><circle cx="9" cy="8" r="2.4" fill="none" stroke="#57534e" stroke-width="1"/>',
    sand: '<rect width="8" height="8" fill="#fef3c7"/><circle cx="2" cy="2" r="0.9" fill="#a16207"/><circle cx="6" cy="5" r="0.9" fill="#a16207"/>',
    concrete: '<rect width="10" height="10" fill="#e2e8f0"/><path d="M-2,2 l4,-4 M0,10 l10,-10 M8,12 l4,-4" stroke="#475569" stroke-width="1.2"/>',
    paving: '<rect width="14" height="10" fill="#e7e5e4"/><path d="M0,0 h14 M0,5 h14 M7,0 v5 M0,5 v5 M14,5 v5" stroke="#78716c" stroke-width="1"/>',
    grass: '<rect width="12" height="12" fill="#dcfce7"/><path d="M2,10 l1,-4 l1,4 M7,7 l1,-4 l1,4" stroke="#15803d" stroke-width="1" fill="none"/>',
    wood: '<rect width="12" height="12" fill="#fef9c3"/><path d="M0,3 q3,-2 6,0 t6,0 M0,9 q3,-2 6,0 t6,0" stroke="#a16207" stroke-width="1" fill="none"/>',
  };
  const svg = `<svg id="giss-pat-defs" width="0" height="0" style="position:absolute"><defs>${Object.entries(P).map(([k, v]) => { const [w, h] = k === 'paving' ? [14, 10] : k === 'sand' ? [8, 8] : k === 'concrete' ? [10, 10] : [12, 12]; return `<pattern id="pat-${k}" width="${w}" height="${h}" patternUnits="userSpaceOnUse">${v}</pattern>`; }).join('')}</defs></svg>`;
  document.body.insertAdjacentHTML('beforeend', svg);
}
export const patternSwatch = (k) => `<svg width="22" height="14"><rect width="22" height="14" fill="url(#pat-${k})" stroke="#334155"/></svg>`;
